import React, { useState } from 'react';
import {
  Badge,
  Checkbox,
  ColorBadge,
  IconClock,
  IconIfood,
  IconMotorcycle,
  IconTakeat,
  IconTakeatFilled,
  Spinner,
} from 'takeat-design-system-ui-kit';
import { useTheme } from 'styled-components';
import { format } from 'date-fns';
import { useAuth } from '~/context/AuthContext';
import api2 from '~/services/api2';
import toast from 'react-hot-toast';
import { pt } from 'date-fns/locale';
import logoNeemo from '../../../../assets/img/neemo-logo.png';
import {
  CardHeaderContainer,
  ColorBorder,
  FirstRow,
  IfoodTurboBadge,
  Row,
  SecondRow,
  TextWithdrawal,
} from './styles';
import logo99food from '../../../../assets/img/logo-99food.png';
import logoWabiz from '../../../../assets/img/logo-wabiz.png';
import logoKeeta from '../../../../assets/img/logo-keeta.png';
import { useDeliveryKanbanStore } from 'store/kanbanDeliveyStore';

const Logo = ({ basket, channel, theme }) => {
  if (channel === '99FOOD') {
    return (
      <img src={logo99food} title="99Food" style={{ width: 25, height: 25 }} />
    );
  }
  if (channel === 'KEETA') {
    return (
      <img src={logoKeeta} title="Keeta" style={{ width: 25, height: 25 }} />
    );
  }
  if (channel === 'WABIZ') {
    return (
      <img src={logoWabiz} title="Wabiz" style={{ width: 25, height: 25 }} />
    );
  }
  if (basket.ifood_id) {
    return <IconIfood fill={theme.colors.primary.default} />;
  }
  if (basket.neemo_id) {
    return (
      <img src={logoNeemo} title="Neemo" style={{ width: 25, height: 25 }} />
    );
  }
  return (
    <IconTakeatFilled
      style={{ fontSize: '20px', flexShrink: 0 }}
      fill={theme.colors.primary.default}
    />
  );
};

function searchTableName(table, item) {
  if (table.table_type === 'delivery') {
    if (item?.with_withdrawal && item?.scheduled_to) {
      return <TextWithdrawal>Retirada Agendada</TextWithdrawal>;
    }
    if (item?.with_withdrawal) {
      return (
        <ColorBorder>
          <span>Retirada</span>
        </ColorBorder>
      );
    }

    if (!item?.with_withdrawal && item?.scheduled_to) {
      return <TextWithdrawal>Delivery Agendado</TextWithdrawal>;
    }

    return 'Delivery';
  }

  if (table.table_type === 'prepaid') {
    return `Mesa  ${table.table_number} - Pagamento Antecipado`;
  }

  return `Mesa  ${table.table_number}`;
}

function hasThirtySecondsPassed(isoString) {
  return new Date(isoString).getTime() + 30_000 < Date.now();
}

export const DeliveryCardHeader = ({ item, isOngoing }) => {
  const theme = useTheme();
  const { user } = useAuth();

  const [foodyResponseWait, setFoodyResponseWait] = useState();
  const checked = useDeliveryKanbanStore((state) => {
    return (
      state.list.length > 0 &&
      state.list.every((entry) => entry.status !== item?.basket?.order_status)
    );
  });
  const toggleCheckbox = useDeliveryKanbanStore(
    (state) => state.toggleCheckbox
  );

  const hasCheck = useDeliveryKanbanStore((state) =>
    state.list.some((entry) => Number(entry.id) === Number(item?.basket?.id))
  );

  return (
    <CardHeaderContainer>
      <FirstRow>
        {item?.basket.order_status !== 'delivered' &&
          item?.basket.order_status !== 'pending' && (
            <Checkbox
              disabled={checked}
              checked={hasCheck}
              onClick={() => {
                toggleCheckbox(
                  item.basket.id,
                  item?.basket?.order_status,
                  item?.basket?.ifood_id,
                  item?.with_withdrawal
                );
              }}
            />
          )}

        <Logo
          basket={item?.basket}
          channel={item?.sales_channel}
          theme={theme}
        />

        <span>#{item?.attendance_password}</span>

        <span style={{ flexGrow: 1 }}>
          {item?.table.table_type === 'command' &&
            item?.table.table_type !== 'delivery' ? (
            `Comanda  ${item.table.table_number} / Mesa ${item?.basket?.command_table_number || 'não informada'
            } `
          ) : (
            <>
              {item?.basket?.ifood_table
                ? item?.basket?.ifood_table
                : searchTableName(item?.table, item)}
            </>
          )}
        </span>

        {!item?.scheduled_to && (
          <span style={{ fontSize: 14 }}>
            {format(new Date(item?.basket.start_time), 'dd/MM/yy')}
          </span>
        )}
      </FirstRow>

      <SecondRow>
        {(item?.basket?.delivery_mode === 'TURBO' && !item?.with_withdrawal) && (
          <IfoodTurboBadge>
            <IconIfood
              style={{
                fill: "#C8131B",

              }}
              fontSize={22}
            />
            <span style={{ display: 'flex', gap: 2 }}>
              <span
                style={{ fontWeight: 700, fontSize: 12 }}

              >
                Turbo
              </span>
              <span>
                iFood
              </span>
            </span>
          </IfoodTurboBadge>
        )}
        {item?.ifood_restaurant?.name && (
          <span style={{ textAlign: 'left' }}>
            {item.ifood_restaurant.name}
          </span>
        )}

        {item?.scheduled_to ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <b style={{ fontSize: 12 }}>Agendado para:</b>
              <b>{format(new Date(item?.scheduled_to), 'dd/MM/yy')}</b>
            </div>
            <span
              style={{ flexGrow: 1, textAlign: 'end', alignItems: 'center' }}
            >
              <IconClock fontSize={12} />
              {format(new Date(item?.basket?.start_time), "dd/MM - HH'h'mm")}
            </span>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              gap: 4,
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
              flexGrow: 1,
              alignItems: 'center',
            }}
          >
            <span style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
              <IconClock fontSize={12} />{' '}
              {format(new Date(item?.basket.start_time), "HH'h'mm")}
            </span>
            {isOngoing && item.ongoing_at && (
              <span style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                {' '}
                | <IconMotorcycle />{' '}
                {format(new Date(item.ongoing_at), "HH'h'mm")}
              </span>
            )}
          </div>
        )}
      </SecondRow>
      {item.foody_delivery_session_id ||
        item.basket.order_status === 'pending' ||
        !hasThirtySecondsPassed(item.accepted_at) ? (
        <Row>
          {item.delivery_status === 'accepted' && (
            <ColorBadge style={{ padding: '2px 8px' }} customColor="red">
              Aguardando retirada
            </ColorBadge>
          )}
          {item.delivery_status === 'dispatched' && (
            <ColorBadge style={{ padding: '2px 8px' }} customColor="red">
              Aguardando aceite
            </ColorBadge>
          )}
        </Row>
      ) : null}
    </CardHeaderContainer>
  );
};